import React from "react";
import "./sobreNos-style.css";
import ImgSobre from '../../img/Sobrenos.png';
import iconeSlPriv from '../../img/icons/Lawyer.svg';
import iconeEstacao from '../../img/icons/NewJob.svg';
import iconeSlReuniao from '../../img/icons/MeetingRoom.svg';
import iconeEndFiscal from '../../img/icons/Envelope.svg';
import iconeAuditorio from '../../img/icons/Teacher.svg';



export default function SobreNos() {
  const servicos = [
    { icon:iconeSlPriv, label: "Salas Privativas" },
    { icon: iconeEstacao, label: "Estações de Trabalho" },
    { icon: iconeSlReuniao, label: "Sala de Reunião" },
    { icon: iconeEndFiscal, label: "Endereço Fiscal e Comercial" },
    { icon: iconeAuditorio, label: "Salão de eventos" },
  ];

  return (
    <section id="sobre" className="sobre-nos">
      <div className="sobre-nos__container">
        {/* LADO ESQUERDO */}
        <div className="sobre-nos__left">
          <img src={ImgSobre} alt="Espaço do coworking" />
        </div>

        {/* LADO DIREITO */}
        <div className="sobre-nos__right">
          <h1 className="sobre-nos__titulo">
            Melhore sua criatividade <br /> em um ambiente que você merece.
          </h1>

          <ul className="sobre-nos__lista">
            {servicos.map((item, idx) => (
              <li key={idx} className="sobre-nos__item">
                <div className="sobre-nos__icone">
                  <img src={item.icon} alt={item.label} />
                </div>
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
